import { render } from "./student-sidebar.vue?vue&type=template&id=b28b6e72"
import script from "./student-sidebar.vue?vue&type=script&lang=js"
export * from "./student-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__